import { Component, OnDestroy, OnInit, ViewChild, Inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { debounceTime, takeUntil, first } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import {
  EntityCacheProvider,
  NotificationService,
  DevicesService,
  DialogService,
  UserAuth,
  CommonRegEx,
  IPsService,
  IPv4Validation,
  IPv6Validation
} from '@nrwl/common-lib';
import { JmepConfigureService } from '../../../../service/jmep-configure.service';
import { isEqual } from 'lodash';
@Component({
  selector: 'jmepv2-configure',
  templateUrl: './jmepv2-configure-management.component.html',
  styleUrls: ['./jmepv2-configure-management.component.scss']
})
export class JmepV2ConfigureManagementComponent implements OnInit, OnDestroy {
  @ViewChild('jmepForm', { static: true }) form: NgForm;
  interfaceDisabled = false;
  hasReadWriteRole = false;
  isDisabledLoopBackBehavior = false;
  addressIsEmpty = false;
  testIpAddressIsEmpty = false;
  testIpDisabledReason = null;
  gatewayEntity = {
    error: ''
  };
  testIpAddressType = '';
  IP_V4 = 'ipv4';
  IP_V6 = 'ipv6';
  validIPRegex: RegExp = CommonRegEx.IP_V4_V6;
  latitudeIPRegex: RegExp = CommonRegEx.LATITUDE;
  longitudeIPRegex: RegExp = CommonRegEx.LONGITUDE;
  isGatewayIpValid = true;
  isGatewayIpValidFromInventory = false;
  jmepAlarmsData = [];
  deviceList = null;
  testIpEntity = {
    error: ''
  };
  mgmtIpEntity = {
    error: ''
  };
  subnetLengthEntity = {
    placeholder: '1 - 32',
    error: ''
  };
  loopbackInterface = [
    { value: 'disabled', name: 'Disabled' },
    { value: 'port', name: 'Port' },
    { value: 'source', name: 'Source specific' }
  ];
  loopbackBehaviorOptions = [
    { value: 'IgnoreDestinationIP', name: 'Ignore Destination IP' },
    { value: 'LimitToManagementIP', name: 'Limit To Management IP' },
    { value: 'LimitToTestIP', name: 'Limit To Test IP' },
    { value: 'LimitToManagementAndTestIP', name: 'Limit To Management & Test IP' },
    { value: 'disabled', name: 'Disabled' }
  ];
  ARPOptions = [
    { value: 'disabled', name: 'Disabled' },
    { value: 'enableNetworkInterface', name: 'Enable Network Interface' },
    { value: 'enableEquipmentInterface', name: 'Enable Equipment Interface' },
    { value: 'enableBothInterface', name: 'Enable Both Interfaces' }
  ];
  testARPOptions = [
    { value: 'disabled', name: 'Disabled' },
    { value: 'enableNetworkInterface', name: 'Enable Network Interface' },
    { value: 'enableEquipmentInterface', name: 'Enable Equipment Interface' },
    { value: 'enableBothInterface', name: 'Enable Both Interfaces' }
  ];
  dyingGaspOptions = [
    { value: 'disabled', name: 'Disabled' },
    { value: 'enableNetworkInterface', name: 'Enable Network Interface' },
    { value: 'enableEquipmentInterface', name: 'Enable Equipment Interface' }
  ];
  timingMode = [
    { value: 'asynchronous', name: 'Asynchronous' },
    { value: 'synchronous', name: 'Synchronous' }
  ];
  mgmtNetworkpingResponse = [
    { value: 'enableBothInterface', name: 'Enable Both Interfaces' },
    { value: 'disabled', name: 'Disabled' }
  ];
  testNetworkpingResponseOptions = [
    { value: 'enableBothInterface', name: 'Enable Both Interfaces' },
    { value: 'enableNetworkInterface', name: 'Enable Network Interface' },
    { value: 'enableEquipmentInterface', name: 'Enable Equipment Interface' },
    { value: 'disabled', name: 'Disabled' }
  ];
  formData = {
    name: '',
    location: '',
    lat: '',
    lon: '',
    address: '',
    testIpAddress: '',
    gateway: '',
    subnet: '',
    vlan: '',
    testVlan: '',
    selectedTestARP: this.testARPOptions[0],
    selectedModeOption: this.timingMode[0],
    selectedARPOption: this.ARPOptions[0],
    testARPOptions: this.testARPOptions[0],
    selectedDyingGaspOption: this.dyingGaspOptions[0],
    loopbackBehavior: this.loopbackBehaviorOptions[0],
    loopbackBehaviorUpdateValue: this.loopbackBehaviorOptions[0],
    equipmentInterface: this.loopbackInterface[0],
    networkInterface: this.loopbackInterface[0],
    enableViaviHello: false,
    enablePingResponse: this.mgmtNetworkpingResponse[1],
    enableLosPin: false,
    testNetworkpingResponse: this.testNetworkpingResponseOptions[3]
  };
  lastSavedTestPing = this.testNetworkpingResponseOptions[0];
  lastSavedTestARP = this.testARPOptions[3];
  lastSavedTestGateway = '';
  lastSavedTestSubnet = '';
  requestJSONFormat = {
    'config-attributes': {
      name: 'probe-attributes',
      option: [
        {
          name: this.data?.device?.dataItem.nameId,
          id: this.data?.device?.dataItem.id,
          value: {
            data: []
          }
        }
      ]
    }
  };
  badIpValues = ['', '0.0.0.0', '255.255.255.255', '0', '::/0'];
  originalEnablePingResponse = this.mgmtNetworkpingResponse[0];
  originalSelectedARPName = this.ARPOptions[3];
  // eslint-disable-next-line
  fieldsMapping: any;
  formDataCopy: object;
  configData: object;
  loadVersion2Config = false;
  GATEWAY = 'gateway';
  SUBNET = 'subnet';
  IP_ADDRESS = 'address';
  TEST_IP_ADDRESS = 'testIpAddress';
  changedFields: object;
  managementFormDataUpdated = {};
  managementFormData = {};
  finalUpdatedFieldsOptions = [];
  // eslint-disable-next-line
  additionalFieldNames: any;
  fieldValue: string;
  vlanDisabled = 'false';
  savingInProgress = false;
  isLoading = false;
  disableAction = false;
  // eslint-disable-next-line
  JMEP_NAME_REGEX: RegExp = /^[a-zA-Z0-9~@#+$%\-:._]+$/;
  private readonly unsubscribe: Subject<void> = new Subject();
  private formControl = new Subscription();
  constructor(
    public dialogRef: MatDialogRef<JmepV2ConfigureManagementComponent>,
    readonly entityCache: EntityCacheProvider,
    private notificationService: NotificationService,
    private jmepConfigureService: JmepConfigureService,
    private readonly deviceService: DevicesService,
    private readonly dialogService: DialogService,
    private readonly userAuth: UserAuth,
    private readonly ipsService: IPsService,
    @Inject(MAT_DIALOG_DATA) public data: any // eslint-disable-line
  ) {
    this.hasReadWriteRole = this.userAuth.isAuthedFor('READ_WRITE');
  }
  //eslint-disable-next-line
  ngOnInit() {
    this.isLoading = true;
    this.fieldsMapping = this.getFieldsAttributesMapping();
    const reqData = {
      name: this.data?.device?.dataItem.nameId,
      id: this.data?.device?.dataItem.id
    };
    this.jmepConfigureService
      .getJMEPConfig(reqData)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(res => {
        this.isLoading = false;
        this.configData = res.data;
        this.initConfigDetails();
      });
    this.formControl = this.form.control.valueChanges.pipe(debounceTime(200)).subscribe(() => {
      this.disableAction = this.isFormValueChanged();
    });
    this.getDevicesList();
  }

  ngOnDestroy() {
    this.formControl.unsubscribe();
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
  // eslint-disable-next-line
  getFieldsAttributesMapping() {
    return {
      name: {
        section: 'description',
        attributes: ['display_name'],
        defaultValue: ''
      },
      location: {
        section: 'description',
        attributes: ['location'],
        defaultValue: ''
      },
      lat: {
        section: 'location',
        attributes: ['lat'],
        defaultValue: ''
      },
      lon: {
        section: 'location',
        attributes: ['lon'],
        defaultValue: '',
        additionalFieldsMapping: {
          attributes: [],
          dataValue: []
        }
      },
      address: {
        section: 'network',
        attributes: ['ip'],
        defaultValue: ''
      },
      testIpAddress: {
        section: 'network',
        attributes: ['test_ip'],
        defaultValue: ''
      },
      gateway: {
        section: 'network',
        attributes: ['gateway_ip'],
        defaultValue: ''
      },
      subnet: {
        section: 'network',
        attributes: ['netmask_length'],
        defaultValue: ''
      },
      vlan: {
        section: 'network',
        attributes: ['mgmt_vlan'],
        defaultValue: '',
        additionalFieldsMapping: {
          attributes: ['mgmt_vlan_socp_pass_thru'],
          dataValue: ['false']
        }
      },
      testVlan: {
        section: 'network',
        attributes: ['test_ip_vlan_id'],
        defaultValue: '',
        additionalFieldsMapping: {
          attributes: [],
          dataValue: []
        }
      },
      selectedARPOption: {
        section: 'network',
        attributes: ['arp_adp_enabled_optical', 'arp_adp_enabled_host'],
        dataMapping: [
          {
            dataValue: ['false', 'false'],
            formValue: this.ARPOptions[0]
          },
          {
            dataValue: ['true', 'false'],
            formValue: this.ARPOptions[1]
          },
          {
            dataValue: ['false', 'true'],
            formValue: this.ARPOptions[2]
          },
          {
            dataValue: ['true', 'true'],
            formValue: this.ARPOptions[3]
          }
        ],
        defaultValue: this.ARPOptions[0]
      },
      selectedTestARP: {
        section: 'otherOptions',
        attributes: ['ping_test_ip_arp_adp_enabled_optical', 'ping_test_ip_arp_adp_enabled_host'],
        dataMapping: [
          {
            dataValue: ['false', 'false'],
            formValue: this.testARPOptions[0]
          },
          {
            dataValue: ['true', 'false'],
            formValue: this.testARPOptions[1]
          },
          {
            dataValue: ['false', 'true'],
            formValue: this.testARPOptions[2]
          },
          {
            dataValue: ['true', 'true'],
            formValue: this.testARPOptions[3]
          }
        ],
        defaultValue: this.testARPOptions[0]
      },
      selectedDyingGaspOption: {
        section: 'otherOptions',
        attributes: [
          'dying_gasp_frp_enabled',
          'dying_gasp_optical_link_oam_enabled',
          'dying_gasp_host_link_oam_enabled'
        ],
        dataMapping: [
          {
            dataValue: ['false', 'false', 'false'],
            formValue: this.dyingGaspOptions[0]
          },
          {
            dataValue: ['true', 'true', 'false'],
            formValue: this.dyingGaspOptions[1]
          },
          {
            dataValue: ['true', 'false', 'true'],
            formValue: this.dyingGaspOptions[2]
          }
        ],
        defaultValue: this.dyingGaspOptions[0]
      },
      selectedModeOption: {
        section: 'timing',
        attributes: ['mode'],
        dataMapping: [
          {
            dataValue: ['asynch_timing'],
            formValue: this.timingMode[0]
          },
          {
            dataValue: ['through_timing'],
            formValue: this.timingMode[1]
          }
        ],
        defaultValue: this.timingMode[0]
      },
      enablePingResponse: {
        section: 'otherOptions',
        attributes: ['ping_ems_ip_pingable'],
        dataMapping: [
          {
            dataValue: ['false'],
            formValue: this.mgmtNetworkpingResponse[1]
          },
          {
            dataValue: ['true'],
            formValue: this.mgmtNetworkpingResponse[0]
          }
        ],
        defaultValue: this.mgmtNetworkpingResponse[1]
      },
      testNetworkpingResponse: {
        section: 'otherOptions',
        attributes: ['ping_test_ip_pingable_optical', 'ping_test_ip_pingable_host'],
        dataMapping: [
          {
            dataValue: ['true', 'true'],
            formValue: this.testNetworkpingResponseOptions[0]
          },
          {
            dataValue: ['true', 'false'],
            formValue: this.testNetworkpingResponseOptions[1]
          },
          {
            dataValue: ['false', 'true'],
            formValue: this.testNetworkpingResponseOptions[2]
          },
          {
            dataValue: ['false', 'false'],
            formValue: this.testNetworkpingResponseOptions[3]
          }
        ],
        defaultValue: this.testNetworkpingResponseOptions[3]
      },
      enableLosPin: {
        section: 'los',
        attributes: ['mask_los_pin'],
        dataMapping: [
          {
            dataValue: ['false'],
            formValue: false
          },
          {
            dataValue: ['true'],
            formValue: true
          }
        ],
        defaultValue: false
      },
      equipmentInterface: {
        section: 'loopback',
        attributes: [
          'accept_layer2_port_loopback_request_host',
          'accept_layer3_port_loopback_request_host',
          'accept_layer2_evc_loopback_request_host',
          'accept_layer3_evc_loopback_request_host'
        ],
        dataMapping: [
          {
            dataValue: ['false', 'false', 'false', 'false'],
            formValue: this.loopbackInterface[0]
          },
          {
            dataValue: ['true', 'true', 'false', 'false'],
            formValue: this.loopbackInterface[1]
          },
          {
            dataValue: ['false', 'false', 'true', 'true'],
            formValue: this.loopbackInterface[2]
          }
        ],
        defaultValue: this.loopbackInterface[0]
      },
      networkInterface: {
        section: 'loopback',
        attributes: [
          'accept_layer2_port_loopback_request_optical',
          'accept_layer3_port_loopback_request_optical',
          'accept_layer2_evc_loopback_request_optical',
          'accept_layer3_evc_loopback_request_optical'
        ],
        dataMapping: [
          {
            dataValue: ['false', 'false', 'false', 'false'],
            formValue: this.loopbackInterface[0]
          },
          {
            dataValue: ['true', 'true', 'false', 'false'],
            formValue: this.loopbackInterface[1]
          },
          {
            dataValue: ['false', 'false', 'true', 'true'],
            formValue: this.loopbackInterface[2]
          }
        ],
        defaultValue: this.loopbackInterface[0]
      },
      loopbackBehavior: {
        section: 'loopback',
        attributes: [
          'ip_filter_mgmt_ip_host',
          'ip_filter_mgmt_ip_optical',
          'ip_filter_test_ip_optical',
          'ip_filter_test_ip_host',
          'ignore_ip_for_layer3_loopup_optical',
          'ignore_ip_for_layer3_loopup_host'
        ],
        dataMapping: [
          {
            dataValue: ['false', 'false', 'false', 'false', 'true', 'true'],
            formValue: this.loopbackBehaviorOptions[0]
          },
          {
            dataValue: ['true', 'true', 'false', 'false', 'false', 'false'],
            formValue: this.loopbackBehaviorOptions[1]
          },
          {
            dataValue: ['false', 'false', 'true', 'true', 'false', 'false'],
            formValue: this.loopbackBehaviorOptions[2]
          },
          {
            dataValue: ['true', 'true', 'true', 'true', 'false', 'false'],
            formValue: this.loopbackBehaviorOptions[3]
          },
          {
            dataValue: ['false', 'false', 'false', 'false', 'false', 'false'],
            formValue: this.loopbackBehaviorOptions[4]
          }
        ],
        defaultValue: this.loopbackBehaviorOptions[0]
      },
      enableViaviHello: {
        section: 'loopback',
        attributes: ['respond_to_hello_request_optical', 'respond_to_hello_request_host'],
        dataMapping: [
          {
            dataValue: ['false', 'false'],
            formValue: false
          },
          {
            dataValue: ['true', 'true'],
            formValue: true
          }
        ],
        defaultValue: false
      }
    };
  }
  getTextFormValue(fieldName: string): string {
    const formValue = this.jmepConfigureService.getProbeAttibuteValues(
      this.configData,
      this.fieldsMapping[fieldName].section,
      this.fieldsMapping[fieldName].attributes,
      this.fieldsMapping[fieldName].defaultValue
    );
    return formValue.join();
  }
  // eslint-disable-next-line
  getVlanValue(): any {
    const vlanValue = this.getTextFormValue('vlan');
    const vlanDisabledState = this.jmepConfigureService
      .getProbeAttibuteValues(
        this.configData,
        this.fieldsMapping.vlan.section,
        ['mgmt_vlan_disabled'],
        'false'
      )
      .join();
    return vlanValue === '0' || vlanDisabledState === 'true'
      ? this.fieldsMapping.vlan.defaultValue
      : vlanValue;
  }

  // eslint-disable-next-line
  getTestVlanValue(): any {
    const vlanValue = this.getTextFormValue('testVlan');
    const vlanenableddState = this.jmepConfigureService
      .getProbeAttibuteValues(
        this.configData,
        this.fieldsMapping.testVlan.section,
        ['test_ip_vlan_enabled'],
        'true'
      )
      .join();
    return vlanValue === '0' || vlanenableddState === 'false'
      ? this.fieldsMapping.testVlan.defaultValue
      : vlanValue;
  }

  // eslint-disable-next-line
  initConfigDetails(): any {
    this.formData.name = this.getTextFormValue('name');
    this.formData.location = this.getTextFormValue('location');
    this.formData.lat = this.getTextFormValue('lat');
    this.formData.lon = this.getTextFormValue('lon');
    this.formData.address = this.getTextFormValue('address');
    this.formData.testIpAddress = this.getTextFormValue('testIpAddress');
    this.formData.gateway = this.getTextFormValue('gateway');
    this.formData.subnet = this.getTextFormValue('subnet');
    this.formData.vlan = this.getVlanValue();
    this.formData.testVlan = this.getTestVlanValue();

    this.formData.selectedTestARP = this.jmepConfigureService.getFormValueByAttributes(
      this.configData,
      this.fieldsMapping.selectedTestARP
    );
    this.formData.selectedARPOption = this.jmepConfigureService.getFormValueByAttributes(
      this.configData,
      this.fieldsMapping.selectedARPOption
    );
    this.formData.selectedDyingGaspOption = this.jmepConfigureService.getFormValueByAttributes(
      this.configData,
      this.fieldsMapping.selectedDyingGaspOption
    );
    this.formData.selectedModeOption = this.jmepConfigureService.getFormValueByAttributes(
      this.configData,
      this.fieldsMapping.selectedModeOption
    );
    this.formData.enablePingResponse = this.jmepConfigureService.getFormValueByAttributes(
      this.configData,
      this.fieldsMapping.enablePingResponse
    );
    this.formData.testNetworkpingResponse = this.jmepConfigureService.getFormValueByAttributes(
      this.configData,
      this.fieldsMapping.testNetworkpingResponse
    );
    this.formData.enableLosPin = this.jmepConfigureService.getFormValueByAttributes(
      this.configData,
      this.fieldsMapping.enableLosPin
    );
    this.formData.enableViaviHello = this.jmepConfigureService.getFormValueByAttributes(
      this.configData,
      this.fieldsMapping.enableViaviHello
    );
    this.formData.equipmentInterface = this.jmepConfigureService.getFormValueByAttributes(
      this.configData,
      this.fieldsMapping.equipmentInterface
    );
    this.formData.networkInterface = this.jmepConfigureService.getFormValueByAttributes(
      this.configData,
      this.fieldsMapping.networkInterface
    );
    this.formData.loopbackBehavior = this.jmepConfigureService.getFormValueByAttributes(
      this.configData,
      this.fieldsMapping.loopbackBehavior
    );
    this.formData.loopbackBehaviorUpdateValue = this.formData.loopbackBehavior;

    if (this.badIpValues.includes(this.formData.address)) {
      this.formData.address = '';
    }

    if (this.badIpValues.includes(this.formData.testIpAddress)) {
      this.formData.testIpAddress = '';
    }

    if (this.badIpValues.includes(this.formData.subnet)) {
      this.formData.subnet = '';
    }

    //gateway is set to 0.0.0.0 then UI shows empty input field.
    if ('' === this.formData.gateway || this.badIpValues.includes(this.formData.gateway)) {
      this.formData.gateway = '';
    } else {
      this.isGatewayIpValidFromInventory = true;
    }

    if (this.formData.loopbackBehavior.name === 'disabled') {
      this.isDisabledLoopBackBehavior = true;
    }
    this.cacheSelectedValues();
    this.validateMgmtIpAddress();
    this.validateTestIpAddress();
    this.testIpAddressType = this.getTestIpAddressType();
    this.formDataCopy = JSON.parse(JSON.stringify(this.formData));
    this.onInterfaceChange();
  }

  mgmntArpChanged(): void {
    this.cacheSelectedValues();
    this.validateMgmtIpAddress();
  }

  cacheSelectedValues(): void {
    this.originalEnablePingResponse = this.formData.enablePingResponse;
    this.originalSelectedARPName = this.formData.selectedARPOption;
  }

  validateIpAddressChange(ipSrc: string): void {
    const ipAddress = ipSrc === 'testIP' ? this.formData.testIpAddress : this.formData.address;
    let errorMsg = null;
    if (ipAddress && !this.badIpValues.includes(ipAddress)) {
      const isValid = this.ipsService.isValidIP(ipAddress);
      if (!isValid) {
        errorMsg = 'Not a valid IPv4 or IPv6 address';
      } else if (this.formData.testIpAddress === this.formData.address) {
        errorMsg =
          ipSrc === 'testIP'
            ? 'Test IP and Management IP should not be the same'
            : 'Management IP and Test IP should not be the same';
      } else {
        errorMsg = null;
      }
    }
    if (ipSrc === 'testIP') {
      if (errorMsg) {
        this.form.controls?.ipAddress.setErrors({ regex: 'wrong' });
        this.form.controls?.ipAddress.markAsDirty();
      }
      this.testIpEntity.error = errorMsg;
      this.validateTestIpAddress();
    }

    if (ipSrc === 'mgmtIP') {
      if (errorMsg) {
        this.form.controls?.address.setErrors({ regex: 'wrong' });
        this.form.controls?.address.markAsDirty();
      }
      this.mgmtIpEntity.error = errorMsg;
      this.validateMgmtIpAddress();
    }
  }

  validateMgmtIpAddress(): void {
    if (this.badIpValues.includes(this.formData.address)) {
      this.addressIsEmpty = true;
      this.formData.enablePingResponse = this.mgmtNetworkpingResponse[1];
      this.formData.selectedARPOption = this.ARPOptions[0];
    } else if (this.addressIsEmpty) {
      this.addressIsEmpty = false;
      this.formData.enablePingResponse = this.originalEnablePingResponse;
      this.formData.selectedARPOption = this.originalSelectedARPName;
    }
  }

  validateTestIpAddress(): void {
    if (this.badIpValues.includes(this.formData.testIpAddress)) {
      this.testIpAddressIsEmpty = true;
      this.lastSavedTestPing =
        this.formData.testNetworkpingResponse.value === 'Disabled'
          ? this.testNetworkpingResponseOptions[0]
          : this.formData.testNetworkpingResponse;
      this.lastSavedTestARP =
        this.formData.selectedTestARP.value === 'Disabled'
          ? this.testARPOptions[3]
          : this.formData.selectedTestARP;
      this.lastSavedTestGateway = this.formData.gateway;
      this.lastSavedTestSubnet = this.formData.subnet;
      this.formData.testNetworkpingResponse = this.testNetworkpingResponseOptions[3];
      this.formData.selectedTestARP = this.testARPOptions[0];
      this.formData.gateway = '';
      this.formData.subnet = '';
      this.isGatewayIpValid = true;
    } else {
      if (this.testIpAddressIsEmpty) {
        this.formData.testNetworkpingResponse = this.lastSavedTestPing;
        this.formData.selectedTestARP = this.lastSavedTestARP;
        this.formData.gateway = this.lastSavedTestGateway;
        this.formData.subnet = this.lastSavedTestSubnet;
      }
      this.testIpAddressIsEmpty = false;
      this.testIpAddressType = this.getTestIpAddressType();
      if (this.testIpAddressType === this.IP_V4) {
        this.subnetLengthEntity = {
          placeholder: '1 - 32',
          error: 'Must be 1 - 32'
        };
      } else {
        this.subnetLengthEntity = {
          placeholder: '1 - 128',
          error: 'Must be 1 - 128'
        };
      }
      this.validateGatewayChange();
      this.validateSubnetChange();
    }
  }

  getTestIpAddressType(): string {
    let type = '';
    if (this.formData.testIpAddress && this.ipsService.isValidIP(this.formData.testIpAddress)) {
      const isIpv4 = this.ipsService.isIPv4(this.formData.testIpAddress);
      type = isIpv4 ? this.IP_V4 : this.IP_V6;
    }
    return type;
  }

  validateSubnetChange(): void {
    if (this.formData.subnet) {
      let retval = true;
      if (this.testIpAddressType === this.IP_V4) {
        retval = parseInt(this.formData.subnet) >= 1 && parseInt(this.formData.subnet) <= 32;
        this.subnetLengthEntity['error'] = 'Must be 1 - 32';
      }
      if (this.testIpAddressType === this.IP_V6) {
        retval = parseInt(this.formData.subnet) >= 1 && parseInt(this.formData.subnet) <= 128;
        this.subnetLengthEntity['error'] = 'Must be 1 - 128';
      }
      if (!retval) {
        this.form.controls?.subnet.setErrors({ invalid: 'true' });
        this.form.controls?.subnet.markAsDirty();
      }
    } else {
      this.subnetLengthEntity['error'] = 'required';
      this.form.controls?.subnet.setErrors({ invalid: 'true' });
      this.form.controls?.subnet.markAsDirty();
    }
    this.validateIpAndGateway();
  }

  validateGatewayChange(): void {
    this.isGatewayIpValid = true;
    if (this.badIpValues.includes(this.formData.gateway)) {
      this.gatewayEntity.error = 'required';
      this.form.controls?.gateway.setErrors({ invalid: 'true' });
      this.form.controls?.gateway.markAsDirty();
      this.isGatewayIpValid = false;
    } else {
      if (this.testIpAddressType === this.IP_V4) {
        const isValidIp = this.ipsService.isIPv4(this.formData.gateway);
        if (!isValidIp) {
          this.gatewayEntity.error = 'Not a valid IPv4 address';
          this.form.controls?.gateway.setErrors({ invalid: 'true' });
          this.form.controls?.gateway.markAsDirty();
        }
      } else {
        if (this.testIpAddressType === this.IP_V6) {
          const isValidIp = this.ipsService.isIPv6(this.formData.gateway);
          if (!isValidIp) {
            this.gatewayEntity.error = 'Not a valid IPv6 address';
            this.form.controls?.gateway.setErrors({ invalid: 'true' });
            this.form.controls?.gateway.markAsDirty();
          }
        }
      }
    }
    this.validateIpAndGateway();
  }

  // validate the IP and Gateway in same subnet
  validateIpAndGateway(): void {
    const subnetLength = parseInt(this.formData.subnet, 10);
    if (
      this.ipsService.isValidIP(this.formData.testIpAddress) &&
      this.ipsService.isValidIP(this.formData.gateway) &&
      !isNaN(subnetLength)
    ) {
      const isValidTestIpConfig =
        this.testIpAddressType === this.IP_V4
          ? IPv4Validation.validateIpv4AndGateway(
              this.formData.testIpAddress,
              this.formData.gateway,
              subnetLength
            )
          : IPv6Validation.validateIpv6AndGateway(
              this.formData.testIpAddress,
              this.formData.gateway,
              subnetLength
            );
      if (!isValidTestIpConfig.valid) {
        switch (isValidTestIpConfig.field) {
          case 'subnet':
            this.subnetLengthEntity.error = isValidTestIpConfig.message;
            this.form.controls?.subnet?.setErrors({ invalid: true });
            break;
          case 'gateway':
            this.gatewayEntity.error = isValidTestIpConfig.message;
            this.form.controls?.gateway?.setErrors({ invalid: true });
            break;
          case 'testIP':
            this.testIpEntity.error = isValidTestIpConfig.message;
            this.form.controls?.ipAddress?.setErrors({ invalid: true });
            break;
        }
      } else {
        this.form.controls?.ipAddress?.setErrors(null);
        this.form.controls?.gateway?.setErrors(null);
        this.form.controls?.subnet?.setErrors(null);
      }
    }
  }

  onloopbackBehaviorChange(): void {
    if (this.formData.loopbackBehavior.value === 'disabled') {
      this.formData.equipmentInterface = this.loopbackInterface[0];
      this.formData.networkInterface = this.loopbackInterface[0];
      this.isDisabledLoopBackBehavior = true;
    } else {
      this.isDisabledLoopBackBehavior = false;
    }
    this.onInterfaceChange();
  }
  onInterfaceChange(): void {
    this.interfaceDisabled =
      this.formData.equipmentInterface.value === 'disabled' &&
      this.formData.networkInterface.value === 'disabled';
    if (this.interfaceDisabled) {
      this.formData['loopbackBehaviorUpdateValue'] = this.loopbackBehaviorOptions[4];
    }
  }

  //eslint-disable-next-line
  onClickSelectedValues(value, type) {
    let pingVal = null;
    switch (type) {
      case 'arp':
        this.formData.selectedARPOption = this.ARPOptions.find(item => item.value === value);
        this.mgmntArpChanged();
        break;
      case 'mgmtPing':
        pingVal = this.mgmtNetworkpingResponse.find(item => item.value === value);
        this.formData.enablePingResponse = pingVal;
        this.originalEnablePingResponse = pingVal;
        break;
      case 'testArp':
        this.formData.selectedTestARP = this.testARPOptions.find(item => item.value === value);
        break;
      case 'testNetworkPing':
        this.formData.testNetworkpingResponse = this.testNetworkpingResponseOptions.find(
          item => item.value === value
        );
        break;
      case 'equipmentInterface':
        this.formData.equipmentInterface = this.loopbackInterface.find(
          item => item.value === value
        );
        break;
      case 'behavioroption':
        this.formData.loopbackBehavior = this.loopbackBehaviorOptions.find(
          item => item.value === value
        );
        break;
      case 'networkInterface':
        this.formData.networkInterface = this.loopbackInterface.find(item => item.value === value);
        break;
      case 'selectedDyingGaspOption':
        this.formData.selectedDyingGaspOption = this.dyingGaspOptions.find(
          item => item.value === value
        );
        break;
      case 'modeOption':
        this.formData.selectedModeOption = this.timingMode.find(item => item.value === value);
        break;
    }
  }
  //eslint-disable-next-line
  saveConfigDetails(): any {
    const managementChangedFields = this.filterChangedFields(this.formDataCopy, this.formData);
    if (managementChangedFields && Object.keys(managementChangedFields).length) {
      this.updateConfigManagement(managementChangedFields);
    }
  } //eslint-disable-next-line
  filterChangedFields(oldFormValue: object, newFormValue: object): any {
    const updatedFields = {};
    for (const key of Object.keys(oldFormValue)) {
      if (!isEqual(oldFormValue[key], newFormValue[key])) {
        switch (key) {
          case 'address':
            updatedFields['address'] = newFormValue['address'];
            updatedFields['selectedARPOption'] = newFormValue['selectedARPOption'];
            break;

          case 'subnet':
          case 'gateway':
            updatedFields['subnet'] = newFormValue['subnet'];
            updatedFields['gateway'] = newFormValue['gateway'];
            if (newFormValue['testIpAddress']) {
              updatedFields['testIpAddress'] = newFormValue['testIpAddress'];
            }
            break;

          case 'enablePingResponse':
          case 'testNetworkpingResponse':
          case 'selectedTestARP':
            updatedFields['enablePingResponse'] = newFormValue['enablePingResponse'];
            updatedFields['testNetworkpingResponse'] = newFormValue['testNetworkpingResponse'];
            updatedFields['selectedTestARP'] = newFormValue['selectedTestARP'];
            break;

          case 'lat':
          case 'lon':
          case 'location':
            updatedFields['lat'] = newFormValue['lat'];
            updatedFields['lon'] = newFormValue['lon'];
            updatedFields['location'] = newFormValue['location'];
            break;

          default:
            updatedFields[key] = newFormValue[key];
            break;
        }
      }
    }

    if (
      newFormValue['equipmentInterface']?.name === 'disabled' &&
      newFormValue['networkInterface']?.name === 'disabled' &&
      newFormValue['loopbackBehaviorUpdateValue']
    ) {
      updatedFields['loopbackBehavior'] = newFormValue['loopbackBehaviorUpdateValue'];
    }

    if (!newFormValue['testIpAddress'] || '0.0.0.0' == newFormValue['testIpAddress']) {
      [this.GATEWAY, this.SUBNET].forEach(field => {
        if (field && field in updatedFields) {
          delete updatedFields[field];
        }
      });
    }
    return updatedFields;
  }
  //eslint-disable-next-line
  callBackSaveAck(service): void {
    service.callBackJmepConfigSave();
  }
  //eslint-disable-next-line
  callBackJmepConfigSave(): any {
    this.saveConfigStart(this.changedFields);
  }
  updateConfigManagement(managementChangedFields: object): void {
    this.changedFields = managementChangedFields;
    //eslint-disable-next-line
    if (
      managementChangedFields['testIpAddress'] &&
      this.managementFormDataUpdated?.['selectedTestARP']?.value === 'disabled' &&
      managementChangedFields['testIpAddress'] !== ''
    ) {
      const param = {
        id: 'datasource.jmepConfig',
        alternateMsg: `Changing Test Network IP address when ARP/NDP is disabled will cause<br/>the system to lose communication with the JMEP.Are you sure you want to apply these changes?`,
        callBackService: this,
        callBackFuntion: this.callBackSaveAck
      };
      this.dialogService.showDialog('confirm', 'body', param);
    } else if (
      Object.prototype.hasOwnProperty.call(managementChangedFields, 'address') ||
      Object.prototype.hasOwnProperty.call(managementChangedFields, 'enableLosPin') ||
      Object.prototype.hasOwnProperty.call(managementChangedFields, 'selectedARPOption') ||
      Object.prototype.hasOwnProperty.call(managementChangedFields, 'selectedModeOption')
    ) {
      if (
        !Object.prototype.hasOwnProperty.call(managementChangedFields, 'address') &&
        !Object.prototype.hasOwnProperty.call(managementChangedFields, 'enableLosPin') &&
        Object.prototype.hasOwnProperty.call(managementChangedFields, 'selectedARPOption') &&
        (managementChangedFields['selectedARPOption'].value === 'enableEquipmentInterface' ||
          managementChangedFields['selectedARPOption'].value === 'enableNetworkInterface')
      ) {
        const interfaceName =
          managementChangedFields['selectedARPOption'].value === 'enableEquipmentInterface'
            ? 'network'
            : 'equipment';
        const param = {
          id: 'datasource.jmepConfig',
          alternateMsg:
            `ARP/NDP for the management network is about to be disabled on the ` +
            interfaceName +
            ' ' +
            `interface.
    This could result in loss of communication with the JMEP.Are you sure you want to apply these changes?`,
          callBackService: this,
          callBackFuntion: this.callBackSaveAck
        };
        this.dialogService.showDialog('confirm', 'body', param);
      } else {
        const param = {
          id: 'datasource.jmepConfig',
          alternateMsg: `The settings you have changed may cause the system to lose contact with the JMEP. Are you sure you want to apply these changes?`,
          callBackService: this,
          callBackFuntion: this.callBackSaveAck
        };
        this.dialogService.showDialog('confirm', 'body', param);
      }
    } else if (Object.prototype.hasOwnProperty.call(managementChangedFields, 'loopbackBehavior')) {
      const continueChangesMsg = 'Do you want to continue?';
      if (
        managementChangedFields['loopbackBehavior'].value === 'LimitToManagementIP' &&
        managementChangedFields['address'] === ''
      ) {
        const param = {
          id: 'datasource.jmepConfig',
          alternateMsg:
            `Loopback Behavior is configured to use the Management IP and it is not defined.` +
            continueChangesMsg,
          callBackService: this,
          callBackFuntion: this.callBackSaveAck
        };
        this.dialogService.showDialog('confirm', 'body', param);
      } else if (
        managementChangedFields['loopbackBehavior'].value === 'LimitToTestIP' &&
        managementChangedFields['testIpAddress'] === ''
      ) {
        const param = {
          id: 'datasource.jmepConfig',
          alternateMsg:
            `Loopback Behavior is configured to use the Test IP and it is not defined.` +
            continueChangesMsg,
          callBackService: this,
          callBackFuntion: this.callBackSaveAck
        };
        this.dialogService.showDialog('confirm', 'body', param);
      } else if (
        managementChangedFields['loopbackBehavior'].value === 'LimitToManagementAndTestIP' &&
        managementChangedFields['address'] === '' &&
        managementChangedFields['testIpAddress'] === ''
      ) {
        const param = {
          id: 'datasource.jmepConfig',
          alternateMsg:
            `Loopback Behavior is configured to use the Management and Test IP and they not defined.` +
            continueChangesMsg,
          callBackService: this,
          callBackFuntion: this.callBackSaveAck
        };
        this.dialogService.showDialog('confirm', 'body', param);
      } else {
        this.saveConfigStart(managementChangedFields);
      }
    } else {
      this.saveConfigStart(managementChangedFields);
    }
  }
  //eslint-disable-next-line
  saveConfigStart(updatedFields: any): void {
    this.finalUpdatedFieldsOptions = [];
    this.savingInProgress = true;
    if (updatedFields.address === '' || updatedFields.address === '255.255.255.255') {
      updatedFields.address = '0.0.0.0';
    }
    if (updatedFields.testIpAddress === '' || updatedFields.testIpAddress === '255.255.255.255') {
      updatedFields.testIpAddress = '0.0.0.0';
    }
    this.getUpdatedFieldAttributes(updatedFields);
    this.requestJSONFormat['config-attributes'].option[0].value.data =
      this.finalUpdatedFieldsOptions;
    this.updateJMEPConfig(this.requestJSONFormat);
  }
  //eslint-disable-next-line
  updateJMEPConfig(requestJSONFormat): any {
    this.isLoading = true;
    //eslint-disable-next-line
    this.jmepConfigureService
      .setJMEPConfig(requestJSONFormat)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        res => {
          this.configData = res.data;
          this.isLoading = false;
          this.deviceService.updateCache();
          this.notificationService.onSuccess(
            'Configuration has been applied to JMEP : ' + this.formData.name
          );
          this.dialogRef.close();
        },
        error => {
          this.isLoading = false;
          this.notificationService.onFail(
            'Failed to apply configuration to JMEP : ' +
              this.jmepConfigureService.parseErrorMessage(error?.error?.data?.message)
          );
          this.dialogRef.close();
        }
      );
  }
  //eslint-disable-next-line
  getUpdatedFieldAttributes(updatedFields) {
    for (const key of Object.keys(updatedFields)) {
      const fieldAttributes = this.fieldsMapping[key];
      switch (key) {
        case 'name':
        case 'location':
        case 'address':
        case 'gateway':
        case 'subnet':
        case 'testIpAddress':
          this.createProbeAttributes(
            fieldAttributes.section,
            fieldAttributes.attributes,
            [updatedFields[key]],
            fieldAttributes.additionalFieldsMapping
          );
          break;
        case 'lat':
        case 'lon':
          this.additionalFieldNames = fieldAttributes.additionalFieldsMapping;
          if (this.additionalFieldNames) {
            this.additionalFieldNames.attributes.push('address');
            this.additionalFieldNames.dataValue.push(this.formData.location);
          }
          this.createProbeAttributes(
            fieldAttributes.section,
            fieldAttributes.attributes,
            [updatedFields[key]],
            this.additionalFieldNames
          );
          break;
        case 'vlan':
          this.fieldValue = updatedFields[key] ? updatedFields[key] : '0';
          this.vlanDisabled = updatedFields[key] ? 'false' : 'true';
          this.additionalFieldNames = fieldAttributes.additionalFieldsMapping;
          this.additionalFieldNames.attributes.push('mgmt_vlan_disabled');
          this.additionalFieldNames.dataValue.push(this.vlanDisabled);
          this.createProbeAttributes(
            fieldAttributes.section,
            fieldAttributes.attributes,
            [this.fieldValue],
            this.additionalFieldNames
          );
          break;
        case 'testVlan':
          this.fieldValue = updatedFields[key] ? updatedFields[key] : '0';
          this.vlanDisabled = updatedFields[key] ? 'true' : 'false';
          this.additionalFieldNames = fieldAttributes.additionalFieldsMapping;
          this.additionalFieldNames.attributes.push('test_ip_vlan_enabled');
          this.additionalFieldNames.dataValue.push(this.vlanDisabled);
          this.createProbeAttributes(
            fieldAttributes.section,
            fieldAttributes.attributes,
            [this.fieldValue],
            this.additionalFieldNames
          );
          break;
        case 'selectedModeOption':
        case 'selectedARPOption':
        case 'selectedDyingGaspOption':
        case 'enablePingResponse':
        case 'enableLosPin':
        case 'equipmentInterface':
        case 'networkInterface':
        case 'enableViaviHello':
        case 'selectedTestARP':
        case 'testNetworkpingResponse':
        case 'loopbackBehavior':
          //eslint-disable-next-line
          const fieldValues = fieldAttributes.dataMapping.find(
            data => JSON.stringify(data.formValue) === JSON.stringify(updatedFields[key])
          );
          this.createProbeAttributes(
            fieldAttributes.section,
            fieldAttributes.attributes,
            fieldValues.dataValue,
            fieldAttributes.additionalFieldsMapping
          );
          break;
      }
    }
  }
  isTestIpEditDisabled(): boolean {
    let editDisabled = false;
    if (this.data?.device?.dataItem?.capabilities?.simpleTestConfig?.twampReflector === 'true') {
      editDisabled = true; // Test ip edit disabled when the TWAMP Reflector is enabled
    }
    return editDisabled;
  }
  //eslint-disable-next-line
  createProbeAttributes(section, fieldNames, fieldValues, additionalFieldNames): void {
    const subAttributesArray = [];
    fieldNames.forEach((fieldName, index) => {
      subAttributesArray.push({
        id: fieldName,
        value: fieldValues[index]
      });
    });
    if (additionalFieldNames) {
      additionalFieldNames.attributes.forEach((fieldName, index) => {
        subAttributesArray.push({
          id: fieldName,
          value: additionalFieldNames.dataValue[index]
        });
      });
    }
    const sectionIndex = this.finalUpdatedFieldsOptions.findIndex(field => field.name === section);
    if (sectionIndex >= 0) {
      this.finalUpdatedFieldsOptions[sectionIndex].subAttributes =
        this.finalUpdatedFieldsOptions[sectionIndex].subAttributes.concat(subAttributesArray);
    } else {
      this.finalUpdatedFieldsOptions.push({ name: section, subAttributes: subAttributesArray });
    }
  }

  validateLoopbackFields(): boolean {
    let loopBackError = false;
    if (
      this.formData.loopbackBehavior.value !== 'disabled' &&
      this.formData.equipmentInterface.value === 'disabled' &&
      this.formData.networkInterface.value === 'disabled'
    ) {
      loopBackError = true;
    } else {
      loopBackError = false;
    }
    return loopBackError;
  }
  isFormValueChanged(): boolean {
    return (
      JSON.stringify(this.formDataCopy) === JSON.stringify(this.formData) ||
      this.validateLoopbackFields()
    );
  }

  getDevicesList(): void {
    this.entityCache
      .findEntityCache('device')
      .getValuesAsync()
      .pipe(first())
      .subscribe(device => {
        this.deviceList = device;
      });
  }

  validateNameChange(): void {
    let agents = {};
    if (this.formData.name) {
      if (this.JMEP_NAME_REGEX.test(this.formData.name)) {
        if (this.formData.name && this.deviceList.length) {
          if (this.formDataCopy?.['name'] !== this.formData.name) {
            agents = this.deviceList.find(item => item?.deviceData?.nameId === this.formData.name);
          }
        }
        if (agents && Object.keys(agents)?.length > 0) {
          this.form.controls?.jmepName.setErrors({ uniqueName: 'false' });
          this.form.controls?.jmepName.markAsDirty();
        }
      } else {
        this.form.controls?.jmepName.setErrors({ pattern: 'false' });
        this.form.controls?.jmepName.markAsDirty();
      }
    }
  }
}
